var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmsp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "y80i2pptca"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 10",
    style: {
      fill: "#fff"
    },
    d: "M0 0h22.751v22.75H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4",
    style: {
      fill: "none"
    },
    d: "M0 0h36v36H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 6",
    style: {
      clipPath: "url(#y80i2pptca)"
    },
    transform: "translate(6.624 6.625)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8",
    d: "M11.375 22.75a11.375 11.375 0 1 1 11.376-11.375A11.388 11.388 0 0 1 11.375 22.75m0-21.75a10.375 10.375 0 1 0 10.376 10.375A10.386 10.386 0 0 0 11.375 1",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9",
    d: "M11.375 22.75c-3.745 0-6.791-5.1-6.791-11.375S7.63 0 11.375 0s6.789 5.1 6.789 11.375-3.045 11.375-6.789 11.375m0-21.75C8.182 1 5.584 5.654 5.584 11.375s2.6 10.375 5.791 10.375 5.789-4.654 5.789-10.375S14.567 1 11.375 1",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 10",
    d: "M11.375 22.75a.5.5 0 0 1-.5-.5V.5a.5.5 0 0 1 .5-.5 11.375 11.375 0 1 1 0 22.75m.5-21.738v20.727a10.376 10.376 0 0 0 0-20.727",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11",
    d: "M21.541 15.707H1.206a.5.5 0 0 1-.468-.324 11.239 11.239 0 0 1 0-8.019.5.5 0 0 1 .468-.323h20.335a.5.5 0 0 1 .468.323 11.207 11.207 0 0 1 0 8.02.5.5 0 0 1-.468.323m-19.983-1H21.19a10.181 10.181 0 0 0 0-6.666H1.56a10.216 10.216 0 0 0 0 6.666",
    style: {
      fill: "#fff"
    }
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmsp);
export default __webpack_public_path__ + "static/media/emsp.b64dee1ce59863f98363fc68327875a6.svg";
export { ForwardRef as ReactComponent };